<template lang="pug">
  h2
    slot(name="text")
      small.stayTopFixed(:data-delta="delta", :data-group='group')
        slot {{title}}
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: 'Default header'
    },
    group: {
      type: String,
      required: false,
      default: 'default'
    },
    delta: {
      type: Number,
      required: false,
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// Accordion-Subtitle.vue?9c72fc12